import CrudApi from './crud';
import http from './http';

export const crud = new CrudApi('/admin/tooltips');

export function getTooltipsUpdatedSince(since) {
	return http.get('/admin/tooltips', { params: { updated_since: since } }).then(resp => resp.data.data);
}
